<template>
  <div class="loader__wrapper">
    <div class="loader"></div>
  </div>
</template>

<script>
  export default {
    name: 'Loader'
  }
</script>

<style scoped lang="scss">

  @import "../scss/variables";

  .loader {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    position: relative;
    margin: 0 auto;

    &__wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 0;
      background-color: rgba(255, 255, 255, 0.7);
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: -10px;
      left: -10px;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      border: 2px solid transparent;
      border-top-color: $green;
    }

    &::before {
      z-index: 100;
      animation: spin 1s infinite;
    }

    &::after {
      border: 2px solid #ccc;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue